module.exports = __webpack_public_path__ + "img/Certificate.645bb8a7.jpg";